export default (string: string, length: number) =>
  string?.split(' ')?.slice(0, 8)?.join(' ');
